var exports = {
  "wx": "xdbfd91f1--e8c40e--header",
  "nd": "xdbfd91f1--e8c40e--panel",
  "DD": "xdbfd91f1--e8c40e--title",
  "VN": "xdbfd91f1--e8c40e--close",
};

module.exports = exports;
